<div class="dynamic-form__field" [formGroup]="stepForm" [ngClass]="gridColClass()">
    @switch (field.type) {
        @case ('textarea') {
            <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                <tec-textarea
                    [formControlName]="field.name"
                    [placeholder]="placeholder()"
                    [hasError]="hasError()"
                />
            </tec-form-group>
        }
        @case ('select') {
            @if (usesSelectDropdown()) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-select
                        class="dynamic-form__select"
                        [formControlName]="field.name"
                        [options]="options"
                        [placeholder]="selectPlaceholder"
                        [search]="selectSearch"
                        [disabled]="selectDisabled"
                        [multiple]="isFieldMultiple(field)"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            } @else if (usesChoiceToggle()) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <div class="dynamic-form__toggle-options">
                        <tec-toggle
                            class="dynamic-form__toggle"
                            [formControlName]="field.name"
                            [options]="options"
                            [multiple]="isFieldMultiple(field)"
                            vertical
                            [requireSelection]="requiresToggleSelection(field)"
                        />
                    </div>
                </tec-form-group>
            }
        }
        @case ('radio') {
            @if (usesYesNoField(field)) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <div class="dynamic-form__yes-no">
                        <tec-toggle
                            class="dynamic-form__toggle dynamic-form__toggle--yes-no"
                            [formControlName]="field.name"
                            [options]="options"
                            [multiple]="false"
                            [requireSelection]="requiresToggleSelection(field)"
                        />
                    </div>
                </tec-form-group>
            } @else {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-toggle
                        class="dynamic-form__toggle"
                        [formControlName]="field.name"
                        [options]="options"
                        [multiple]="false"
                        [requireSelection]="requiresToggleSelection(field)"
                    />
                </tec-form-group>
            }
        }
        @case ('checkbox') {
            @if (usesLegalField(field)) {
                <tec-form-group [label]="groupLabel()">
                    <div class="dynamic-form__legal-group">
                        @if (field.options?.length) {
                            @for (option of field.options; track option.value) {
                                <div class="dynamic-form__legal-option">
                                    <tec-toggle-accept
                                        class="dynamic-form__toggle-accept"
                                        vertical
                                        [options]="getLegalToggleOptions(legalControlKey(option.value))"
                                        [label]="legalOptionLabel(option)"
                                        [required]="hasLegalControlError(legalControlKey(option.value))"
                                        (changeValue)="onLegalToggleChange(legalControlKey(option.value), $event)"
                                    />
                                    @if (hasLegalControlError(legalControlKey(option.value))) {
                                        <p class="dynamic-form__error">{{ legalControlErrorMessage(legalControlKey(option.value)) }}</p>
                                    }
                                </div>
                            }
                        } @else {
                            <div class="dynamic-form__legal-option">
                                <tec-toggle-accept
                                    class="dynamic-form__toggle-accept"
                                    vertical
                                    [options]="getLegalToggleOptions(field.name)"
                                    [label]="legalAcceptContentLabel()"
                                    [required]="hasLegalControlError(field.name)"
                                    (changeValue)="onLegalToggleChange(field.name, $event)"
                                />
                                @if (hasLegalControlError(field.name)) {
                                    <p class="dynamic-form__error">{{ legalControlErrorMessage(field.name) }}</p>
                                }
                            </div>
                        }
                    </div>
                </tec-form-group>
            } @else if (usesSelectDropdown()) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-select
                        class="dynamic-form__select"
                        [formControlName]="field.name"
                        [options]="options"
                        [placeholder]="selectPlaceholder"
                        [search]="selectSearch"
                        [disabled]="selectDisabled"
                        [multiple]="isFieldMultiple(field)"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            } @else if (usesChoiceToggle()) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <div class="dynamic-form__toggle-options">
                        <tec-toggle
                            class="dynamic-form__toggle"
                            [formControlName]="field.name"
                            [options]="options"
                            [multiple]="isFieldMultiple(field)"
                            vertical
                            [requireSelection]="requiresToggleSelection(field)"
                        />
                    </div>
                </tec-form-group>
            } @else if (usesCheckboxGroup(field)) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-checkbox-group
                        class="dynamic-form__checkbox-group"
                        [formControlName]="field.name"
                        [options]="options"
                        [multiple]="isFieldMultiple(field)"
                    />
                </tec-form-group>
            }
            @if (usesBooleanCheckbox(field)) {
                <tec-switch [formControlName]="field.name" [label]="groupLabel()" size="sm" />
            }
        }
        @case ('file') {
            <tec-form-group [label]="groupLabel()">
                @if (field.description) {
                    <p class="dynamic-form__file-description">{{ placeholder() }}</p>
                }
                <tec-upload
                    [hasButton]="true"
                    [formControlName]="field.name"
                    [browseButtonLabel]="'GENERAL.BUTTON.ATTACH' | translate"
                    (fileSelected)="onUploadFiles($event)"
                />
            </tec-form-group>
        }
        @default {
            @if (isDateField(field)) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-datepicker
                        [formControlName]="field.name"
                        [placeholder]="placeholder()"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            } @else if (isNumberField(field)) {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-input
                        [formControlName]="field.name"
                        [placeholder]="placeholder()"
                        type="number"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            } @else if (isPhoneField(field)) {
                <!-- TODO: [NIF-519] Sustituir por phone-input de Infinity cuando esté adaptado -->
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <app-phone-input
                        [formControlName]="field.name"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            } @else {
                <tec-form-group [label]="groupLabel()" [errorMsg]="errorMessage()">
                    <tec-input
                        [formControlName]="field.name"
                        [placeholder]="placeholder()"
                        [type]="inputType()"
                        [hasError]="hasError()"
                    />
                </tec-form-group>
            }
        }
    }
</div>
